import { render, staticRenderFns } from "./MainHeadline.vue?vue&type=template&id=146de1ba&scoped=true&"
import script from "./MainHeadline.vue?vue&type=script&lang=js&"
export * from "./MainHeadline.vue?vue&type=script&lang=js&"
import style0 from "./MainHeadline.vue?vue&type=style&index=0&id=146de1ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146de1ba",
  null
  
)

export default component.exports